module.exports = __webpack_public_path__ + "img/pinme_black.b1f68b39.svg";